import './styles/main.coupon.scss'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource';
// import City from './components/City.vue'
import Coupon from './components/Coupon.vue'
import Result from './components/Result.vue'
import NetError from './components/Error.vue'
import store from './vuex/store.js'

Vue.use(VueRouter);
Vue.use(VueResource);

var router = new VueRouter();

router.map({
    '/coupon': {
        name: 'coupon',
        component: Coupon
    },
    '/result': {
        name: 'result',
        component: Result
    },
    // '/city': {
    //     name: 'city',
    //     component: City
    // },
    '/error': {
        name: 'error',
        component: NetError
    }
});

var App = Vue.extend({
    store,
    data() {
        var pagedata = {
            key: 'ybw6mFaU0GuLXvcH33njtYoaRA2Tn4qs'
        }
        return {
            pagedata: pagedata //页面公共数据
        }
    },
    template: '<div><router-view :pagedata="pagedata"></router-view></div>',
    created() {
        var that = this
        that.getWxData()
    },
    methods: {
        getWxData() {
            var that = this;
            const shareUrl = encodeURIComponent(window.shareAppData.linkUrl)
            that.$http.get(window.weixinShareUrl + '/jzapp/api/getWechatShare?accountType=6&url=' + encodeURIComponent(shareUrl), {}).then(function(res) {
                const result = JSON.parse(res.data)
                if (!result.data) return
                var d = result.data
                wx.config({
                    debug: false,
                    appId: d.appId,
                    timestamp: d.timeStamp,
                    nonceStr: d.nonceStr,
                    signature: d.signature,
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'hideMenuItems',
                        'showMenuItems',
                        'hideAllNonBaseMenuItem',
                        'showAllNonBaseMenuItem',
                        'translateVoice',
                        'startRecord',
                        'stopRecord',
                        'onRecordEnd',
                        'playVoice',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'chooseImage',
                        'previewImage',
                        'uploadImage',
                        'downloadImage',
                        'getNetworkType',
                        'openLocation',
                        'getLocation',
                        'hideOptionMenu',
                        'showOptionMenu',
                        'closeWindow',
                        'scanQRCode',
                        'chooseWXPay',
                        'openProductSpecificView',
                        'addCard',
                        'chooseCard',
                        'openCard'
                    ]
                });
            })
        }
    }
})

router.redirect({
    '*': '/coupon'
})

router.start(App, '#app');



// WEBPACK FOOTER //
// ./src/main.js